import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { WorkspaceBasicInfo } from './WorkspaceBasicInfo';
import { WorkspaceNavigationItemInfo } from '../../../navigation/components/Workspaces/gql/generated/WorkspaceNavigationItemInfo';
import { WorkspaceContextMenuInfo } from '../../../navigation/components/Workspaces/gql/generated/WorkspaceContextMenuInfo';
import { WorkspacePermissions } from './WorkspacePermissions';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetWorkspacesForNavigationQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
  filter?: Types.InputMaybe<Types.WorkspaceFilterInput>;
  order?: Types.InputMaybe<Types.WorkspaceOrderInput>;
}>;


export type GetWorkspacesForNavigationQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, permissions?: { __typename?: 'AccountPermissions', canCreateWorkspace: boolean, canManageResourceControlPolicies: boolean } | null, subscription: { __typename?: 'AccountSubscription', id: string, limitedResources?: { __typename?: 'LimitedResources', workspaces?: { __typename?: 'LimitedResource', limit53?: number | null } | null } | null }, workspaces: { __typename?: 'WorkspaceConnection', totalCount: number, nodes: Array<{ __typename?: 'Workspace', id: string, isWorkfront?: boolean | null, name: string, projectNotificationsEnabled?: boolean | null, externallyManagedIntegration?: { __typename?: 'ExternallyManagedIntegration', integration?: Types.Integration | null, canUpdateInternalAssetContentSecurity: boolean, canUpdateWorkspaceName: boolean } | null, images?: { __typename?: 'Images', image128?: string | null, image32?: string | null, image64?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null } | null, permissions?: { __typename?: 'WorkspacePermissions', canCreateProject: boolean, canDelete: boolean, canEditUserPermissions: boolean, canManageResourceControlPolicies: boolean, canUpdate: boolean } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };


export const GetWorkspacesForNavigation = /*#__PURE__*/ gql`
    query GetWorkspacesForNavigation($accountId: ID!, $page: PageInput!, $filter: WorkspaceFilterInput, $order: WorkspaceOrderInput) {
  account(accountId: $accountId) {
    id
    permissions {
      canCreateWorkspace
      canManageResourceControlPolicies
    }
    subscription {
      id
      limitedResources {
        workspaces {
          limit53
        }
      }
    }
    workspaces(page: $page, filter: $filter, order: $order) {
      nodes {
        ...WorkspaceBasicInfo
        ...WorkspaceNavigationItemInfo
        ...WorkspaceContextMenuInfo
        ...WorkspacePermissions
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    ${WorkspaceBasicInfo}
${WorkspaceNavigationItemInfo}
${WorkspaceContextMenuInfo}
${WorkspacePermissions}` as unknown as DocumentNode<GetWorkspacesForNavigationQuery, GetWorkspacesForNavigationQueryVariables>;

          

          export const useGetWorkspacesForNavigationQuery = (options?:QueryHookOptions<GetWorkspacesForNavigationQuery, GetWorkspacesForNavigationQueryVariables>) => useQuery(GetWorkspacesForNavigation, options);

          

          export type GetWorkspacesForNavigationQueryOptions = QueryHookOptions<GetWorkspacesForNavigationQuery, GetWorkspacesForNavigationQueryVariables>;

          

          export const useGetWorkspacesForNavigationLazyQuery = (options?:LazyQueryHookOptions<GetWorkspacesForNavigationQuery, GetWorkspacesForNavigationQueryVariables>) => useLazyQuery(GetWorkspacesForNavigation, options);

          

          export type GetWorkspacesForNavigationQueryResult = ReturnType<typeof useGetWorkspacesForNavigationQuery>;

          
